import { Col, Row } from "react-bootstrap";
import "./skeleton-screen.css";

const SkeletonScreen = ({ count = 3 }) => {
    return (
        <Row className="row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4 mb-3">
            {Array.from({ length: count }).map((_, index) => (
                <Col key={index}>
                    <div className="skeleton-card">
                        <div className="skeleton-box"></div>
                    </div>
                </Col>
            ))}
        </Row>
    );
};

export default SkeletonScreen;
